import React, { Component, ErrorInfo, ReactNode } from 'react';
import { triggerAppError } from '../Redirection';
import axios from 'axios';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ hasError: true });
    const fullUrl = `${window.location.origin}/v1/log/log_react_error`;
    const token = localStorage.getItem('xcsrf');

    axios
      .post(
        fullUrl,
        {
          message: error.name + ': ' + error.message,
          errorinfo: errorInfo,
        },
        {
          headers: {
            'X-CSRF-Token': token,
          },
        }
      )
      .catch((error) => {});
    triggerAppError(true);
  }

  public render() {
    if (this.state.hasError) {
      return <div data-test-id="error-boundary">{this.props.children}</div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
